import { Phone, Check } from "lucide-react";

export default function PhoneDisplay({
  phone,
  isVerified = false,
  className = "",
}) {
  return (
    <span
      className={`text-gray-500 flex justify-center gap-1 items-center ${className}`}
    >
      <Phone size={13} />
      {phone}
      {isVerified && (
        <Check
          size={14}
          className="bg-teal-600 text-white rounded-full"
        />
      )}
    </span>
  );
}